import { render, staticRenderFns } from "./CustomerInformation.vue?vue&type=template&id=d5ef18aa&scoped=true&"
import script from "./CustomerInformation.vue?vue&type=script&lang=ts&"
export * from "./CustomerInformation.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerInformation.vue?vue&type=style&index=0&id=d5ef18aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ef18aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VIcon,VLabel,VSpacer,VTextField,VToolbar})
